import React from 'react';
import { useSeo } from '../hooks/useSeo';
import { Check } from 'lucide-react';
import { FinalContact } from '../components/FinalContact';
const APPLY_URL = 'https://intelliapp.driverapponline.com/c/FSGTransport';
const QUICK_ANSWERS = ['Built for owner-operators', 'OTR support', 'Dispatch coordination', 'Compliance-first expectations', 'Clear communication', 'Apply online'];
const SECTIONS = [{
  title: 'Who This Is For',
  items: ['Owner-operators looking for an OTR home with dispatch coordination', 'Drivers who want a compliance-first process and clear communication', 'Carriers who would rather focus on driving than running the office']
}, {
  title: 'What FSG Expects',
  items: ['Required documents provided and kept current', 'Open communication and dependable check calls', 'A professional, safety-minded approach to the work']
}, {
  title: 'What FSG Helps With',
  items: ['Dispatch coordination and load planning', 'Broker communication, paperwork, and billing support', 'Onboarding, documentation, and compliance-related handoffs']
}, {
  title: 'What Happens After You Apply',
  items: ['FSG reviews your application and setup', 'A team member follows up to discuss next steps', 'Onboarding and document collection begin once it is a fit']
}];
const FAQ = [{
  q: 'Do I need my own authority to lease on?',
  a: 'No. Leasing on is an alternative to running your own authority. FSG can explain how the setup works for your situation.'
}, {
  q: 'What equipment can lease on?',
  a: 'We support common equipment types like dry van, reefer, flatbed, step deck, and power-only. Fit depends on your equipment, location, and current opportunities.'
}, {
  q: 'How soon can I start?',
  a: 'Timing depends on your setup, required documents, and approvals. FSG can explain the next steps once they know your situation.'
}];
export function LeaseOn() {
  useSeo({
    title: 'Lease On With FSG Transport | Owner-Operator OTR Support',
    description: 'Lease on with FSG Transport for a compliance-first OTR setup with dispatch coordination, clear communication, and support that helps keep trucks moving.',
    path: '/lease-on-with-fsg'
  });
  return <div className="w-full" data-id="element-514">
      <section className="relative bg-navy text-white pt-36 pb-20 lg:pt-44 lg:pb-28 overflow-hidden" data-id="element-515">
        <div className="absolute inset-0 z-0 opacity-30" data-id="element-516">
          <img src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https%3A//assets.cdn.filesafe.space/cMkAnz3QfJpQ1Lp2u0QG/media/69160e581547ed5536c65e53.jpg" alt="Truck on the highway" className="w-full h-full object-cover" data-id="element-517" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-transparent" data-id="element-518" />
        </div>
        <div className="container-custom relative z-10 max-w-3xl" data-id="element-519">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black leading-[1.1] mb-6 tracking-tight font-['Barlow']" data-id="element-520">
            Lease On With FSG Transport
          </h1>
          <p className="text-lg text-off-white/80 font-medium leading-relaxed mb-8" data-id="element-521">
            For owner-operators looking for a compliance-first OTR setup with
            dispatch coordination, clear communication, and support that helps
            keep trucks moving.
          </p>
          <a href={APPLY_URL} target="_blank" rel="noopener noreferrer" className="btn-primary" data-id="element-522">
            Apply Today
          </a>
        </div>
      </section>

      <section className="bg-black text-white py-10" data-id="element-523">
        <div className="container-custom" data-id="element-524">
          <h2 className="text-sm font-bold uppercase tracking-widest text-amber mb-6" data-id="element-525">
            Quick Lease-On Answers
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-526">
            {QUICK_ANSWERS.map((ans, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-sm p-4 text-sm font-semibold text-center flex items-center justify-center" data-id="element-527">
                {ans}
              </div>)}
          </div>
        </div>
      </section>

      <section className="section-padding bg-off-white" data-id="element-528">
        <div className="container-custom grid md:grid-cols-2 gap-8" data-id="element-529">
          {SECTIONS.map((sec, i) => <div key={i} className="bg-white border border-steel rounded-sm p-8 h-full" data-id="element-530">
              <h2 className="text-xl font-bold text-navy mb-5" data-id="element-531">{sec.title}</h2>
              <ul className="space-y-3" data-id="element-532">
                {sec.items.map((item, j) => <li key={j} className="flex items-start gap-3" data-id="element-533">
                    <Check className="w-5 h-5 text-red shrink-0 mt-0.5" data-id="element-534" />
                    <span className="text-body font-medium" data-id="element-535">{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </section>

      <section className="section-padding bg-white border-t border-steel" data-id="element-536">
        <div className="container-custom max-w-3xl" data-id="element-537">
          <h2 className="text-3xl font-black text-navy mb-8 tracking-tight" data-id="element-538">
            Lease-On FAQ
          </h2>
          <div className="space-y-5" data-id="element-539">
            {FAQ.map((f, i) => <div key={i} className="border-l-2 border-red pl-5" data-id="element-540">
                <h3 className="font-bold text-navy mb-1" data-id="element-541">{f.q}</h3>
                <p className="text-body font-medium leading-relaxed" data-id="element-542">{f.a}</p>
              </div>)}
          </div>
          <div className="mt-10" data-id="element-543">
            <a href={APPLY_URL} target="_blank" rel="noopener noreferrer" className="btn-primary" data-id="element-544">
              Apply to Lease On
            </a>
          </div>
        </div>
      </section>

      <FinalContact data-id="element-545" />
    </div>;
}